import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/tailwind.css'
import interceptor from './utils/interceptor'

import './assets/app.scss'

interceptor()


const app = createApp(App)
// Prevent file dropping outside the designated file input area
window.addEventListener('dragover', (e) => {
    if (!e.target.classList.contains('file-input')) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
  
  window.addEventListener('drop', (e) => {
    if (!e.target.classList.contains('file-input')) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
app.use(store).use(router).mount('#app');
